import { InteractionType, OutgoingState, Direction, } from '@debbie/common/dist/interactions/index.js';
import * as interactions from '../api/interactions.js';
import * as templatesAPI from '../api/templates.js';
import { dispatch } from '../internal.js';
import * as actionTypes from './actionTypes.js';
import q from '../query.js';
import { interactionsEntity } from '../interactions/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
export const createNewInteraction = (id) => dispatch({
    type: actionTypes.CREATE_NEW_INTERACTION,
    payload: { id },
});
export const addFiles = (id, files) => dispatch({
    type: actionTypes.ADD_FILE,
    payload: { id, files },
});
export const changeField = (id, interactionName, fieldName, value) => {
    dispatch({
        type: actionTypes.CHANGE_FIELD,
        payload: { id, interactionName, fieldName, value },
    });
};
export const changeSender = (id, fromId) => {
    dispatch({
        type: actionTypes.CHANGE_SENDER,
        payload: { id, fromId },
    });
};
export const removeFile = (id, index) => dispatch({
    type: actionTypes.REMOVE_FILE,
    payload: { id, index },
});
export const selectTemplate = (id, editorName, template) => dispatch({
    type: actionTypes.SELECT_TEMPLATE,
    payload: { id, editorName, template },
});
export const changeEditorState = (id, editorName, editorState) => dispatch({
    type: actionTypes.CHANGE_EDITOR_STATE,
    payload: { id, editorName, editorState },
});
export const changeEmailSubjectEditorState = (id, editorState) => dispatch({
    type: actionTypes.CHANGE_EMAIL_SUBJECT_EDITOR_STATE,
    payload: { id, editorState },
});
export const changeEBoksSubjectEditorState = (id, editorState) => dispatch({
    type: actionTypes.CHANGE_EBOKS_SUBJECT_EDITOR_STATE,
    payload: { id, editorState },
});
export const sendNote = async (referenceId, referenceType, options, note, uploadedFiles, minVisibilityRole) => {
    dispatch({
        type: actionTypes.SEND_NOTE_START,
        payload: { id: referenceId },
    });
    await interactions.create({
        referenceType,
        referenceId,
        direction: options.direction,
        state: OutgoingState.SENT,
        type: options.type,
        attachments: uploadedFiles.map((f) => f.fileId),
        details: {},
        minVisibilityRole,
        notes: note.editorState,
    });
    q.invalidate(keys.write.create(interactionsEntity));
    dispatch({
        type: actionTypes.SEND_NOTE_SUCCESS,
        payload: { id: referenceId },
    });
};
export const sendEmail = async (referenceId, referenceType, templateId, details, attachments, minVisibilityRole, intent) => {
    try {
        dispatch({
            type: actionTypes.SEND_EMAIL_START,
            payload: { id: referenceId },
        });
        try {
            await interactions.create({
                referenceType,
                referenceId,
                templateId: templateId || null,
                direction: Direction.OUTGOING,
                state: OutgoingState.SENT,
                type: InteractionType.Email,
                details,
                attachments,
                minVisibilityRole,
                intent,
            });
            q.invalidate(keys.write.create(interactionsEntity));
            dispatch({
                type: actionTypes.SEND_EMAIL_SUCCESS,
                payload: { id: referenceId },
            });
        }
        catch (error) {
            console.error(error);
            alert('Error');
            dispatch({
                type: actionTypes.SEND_EMAIL_ERROR,
                payload: { id: referenceId },
            });
        }
    }
    catch (e) {
        alert('Error. Email could not be sent.');
    }
};
export const sendLetter = async (referenceId, referenceType, templateId, letterBody, pdfBody, collector, minVisibilityRole, address, intent) => {
    dispatch({
        type: actionTypes.SEND_LETTER_START,
        payload: { id: referenceId },
    });
    const { pdfFileId } = await templatesAPI.genLetterPDF(templateId, referenceId, {
        body: pdfBody,
        referenceId,
    });
    await interactions.create({
        referenceId,
        referenceType,
        templateId: templateId || null,
        direction: Direction.OUTGOING,
        state: OutgoingState.QUEUED,
        type: InteractionType.Letter,
        details: {
            address,
            folder: collector.envelope,
            pdf: pdfFileId,
        },
        minVisibilityRole,
        intent,
    });
    q.invalidate(keys.write.create(interactionsEntity));
    dispatch({
        type: actionTypes.SEND_LETTER_SUCCESS,
        payload: { id: referenceId },
    });
};
export const sendEBoks = async (referenceId, referenceType, templateId, pdfBody, eBoksTitle, minVisibilityRole, intent, recipient) => {
    dispatch({
        type: actionTypes.SEND_EBOKS_START,
        payload: { id: referenceId },
    });
    const { pdfFileId } = await templatesAPI.genLetterPDF(templateId, referenceId, {
        body: pdfBody,
        referenceId,
    });
    await interactions.create({
        referenceId,
        referenceType,
        templateId: templateId || null,
        direction: Direction.OUTGOING,
        state: OutgoingState.SENT,
        type: InteractionType.Eboks,
        details: {
            pdf: pdfFileId,
            recipient,
            title: eBoksTitle,
        },
        minVisibilityRole,
        intent,
    });
    q.invalidate(keys.write.create(interactionsEntity));
    dispatch({
        type: actionTypes.SEND_EBOKS_SUCCESS,
        payload: { id: referenceId },
    });
};
export const registerPhoneCall = async (referenceId, referenceType, phone, minVisibilityRole) => {
    dispatch({
        type: actionTypes.REGISTER_CALL_START,
        payload: { id: referenceId },
    });
    await interactions.create({
        referenceId,
        referenceType,
        direction: phone.direction,
        state: OutgoingState.SENT,
        type: InteractionType.Phone,
        notes: phone.editorState,
        details: {
            phone: phone.phone,
            tags: phone.tags,
        },
        minVisibilityRole,
    });
    q.invalidate(keys.write.create(interactionsEntity));
    dispatch({
        type: actionTypes.REGISTER_CALL_SUCCESS,
        payload: { id: referenceId },
    });
};
export const sendSMS = async (referenceId, referenceType, sms, details, minVisibilityRole, intent) => {
    dispatch({
        type: actionTypes.SEND_SMS_START,
        payload: { id: referenceId },
    });
    await interactions.create({
        referenceId,
        referenceType,
        templateId: sms.templateId || null,
        direction: Direction.OUTGOING,
        state: OutgoingState.SENT,
        type: InteractionType.SMS,
        details,
        minVisibilityRole,
        intent,
    });
    q.invalidate(keys.write.create(interactionsEntity));
    //reset State
    dispatch({ type: actionTypes.SEND_SMS_SUCCESS, payload: { id: referenceId } });
};
export const registerAutoCall = async (referenceId, referenceType, autocall, details, minVisibilityRole) => {
    dispatch({
        type: actionTypes.REGISTER_AUTO_CALL_START,
        payload: { id: referenceId },
    });
    await interactions.create({
        referenceId,
        referenceType,
        templateId: autocall.templateId || null,
        direction: Direction.OUTGOING,
        state: OutgoingState.SENT,
        type: InteractionType.AutoCall,
        details,
        minVisibilityRole,
    });
    q.invalidate(keys.write.create(interactionsEntity));
    dispatch({
        type: actionTypes.REGISTER_AUTO_CALL_SUCCESS,
        payload: { id: referenceId },
    });
};
//# sourceMappingURL=actions.js.map